import Backbone from 'backbone';
import M from 'backbone.marionette'
import { CoteInput } from './coteInput';
import T from './recotedetails.html'
import Thistory from './recoteHistory.html'
import moment from 'moment'
import { Cote } from '../cote';
import TCarrerStats from './careerStats.html'
import { showModal } from '../../utils/modal';

const RecoteHistoyItem = M.View.extend({
    className: 'list-group-item',
    serializeData: function(){
        return _.extend(this.model.toJSON(), {
            date: moment(this.model.get('created')).calendar(),
            justifications: this.model.get('justifications') ? this.model.get('justifications') : ''
        })
    },
    template: _.template('<strong><%=first_name%> <%=last_name%></strong> | <%=date%> | <span class="cote"></span> <%=justifications%>'),
    regions: {
        'cote':'.cote',  
    },
    onRender: function(){
        this.showChildView('cote', new Cote({model: this.model}));
    }
})

const RecoteHistory = M.CollectionView.extend({
    template:_.template(Thistory),
    ui: {
        'historyListGroup':'.historyListGroup',
        'recoteCount': '.recoteCount'
    },
    triggers: {
        'click a.toggleHistory':'toggle:history'
    },
    serializeData: function(){
        return {
            count: this.collection.length
        }
    },
    collectionEvents: {
        'add':'updateRecoteCount',
        'remove':'updateRecoteCount',
        'reset':'updateRecoteCount',
    },
    childViewContainer:'.historyListGroup',
    childView: RecoteHistoyItem,
    onToggleHistory: function(){
        this.ui.historyListGroup.slideToggle();
    },
    updateRecoteCount: function(){
        this.ui.recoteCount.text(this.collection.length);
    },
    onRender: function(){
        this.updateRecoteCount();
    }

})

const StatView = M.View.extend({
    tagName: 'p',
    template: _.template('<a target="_blank" href="<%= site_url() %>game/view/<%=gameId%>"><%=gameId%>\t<%=team_code%>\t<%=against_team_code%><%= teamTop=="1" ? "*" : "" %></a>\t<%=division%>\t <%=goal=="1" ? "but" : "aide" %> \t <%=def=="1" ? "(DEF)": "" %> <%=topGoalie=="1" ? "+G" : "" %>')
})

const CotationView = M.View.extend({
    tagName: 'p',
    serializeData: function(){
        const out = this.model.toJSON();
        switch(this.model.get('cote')){
            case '1':
                out.cote_text = 'Inférieur';
                break;
            case '2':
                out.cote_text = 'Convenable';
                break;
            case '3':
                out.cote_text = 'Fort';
                break;
            case '4':
                out.cote_text = 'Inadéquat';
                break;
            default:
                out.cote_text = 'N/S';
                break;
        }
        return out
    },
    template: _.template('<strong><%=cote_text %></strong> par <%=first_name%> <%=last_name%><%=comments ? " (" + comments + ")" : ""%>'),
})

const CarrerStatView = M.View.extend({
    tagName: 'tr',
    template: _.template('<td><%=team_code%></td><td><%=division%> | <%= playoff==1 ? "S*" : ""%><%=nom_programme%></td><td><%=pj%></td><td><%=g%></td><td><%=a%></td><td><%=pts%></td><td><%=ppm%></td><td><%=pim%></td>'),
})

const CareerStatsView = M.CollectionView.extend({
    tagName:'table',
    className: 'table',
    template: _.template(TCarrerStats),
    childViewContainer: 'tbody',
    childView: CarrerStatView
})

const StatsView = M.CollectionView.extend({
    tagName:'pre',
    template:_.template(''),
    childView: StatView
});
const CotationsView = M.CollectionView.extend({
    template: _.template(''),
    tagName: 'pre',
    childView: CotationView,
    emptyView: M.View.extend({template: _.template('Aucune évaluation')}),
})

const playerNameView = M.View.extend({
    tagName: 'span',
    template: _.template('<%=first_name%> <%=last_name%> (<%=code%>)'),
    modelEvents: {
        'change':'render'
    }
})

export const RecoteDetails = M.View.extend({
    template: _.template(T),
    cotations: null,
    stats: null,
    careerStats: null,
    history: null,
    player: null,
    serializeData: function(){
        return {
            rank: this.getOption('rank') ? this.getOption('rank').toJSON() : null,
            player: this.player ? this.player.toJSON() : null
        }
    },
    initialize : function(){
        console.log('option', this.options)
        console.log('playerId', this.getOption('playerId'))
        this.cotations = new Backbone.Collection();
        this.stats = new Backbone.Collection();
        this.history = new Backbone.Collection();
        this.careerStats = new Backbone.Collection();
        this.load();
    },
    regions: {
        'cotations':'.cotations',
        'stats':'.stats',
        'careerStats':'.careerStats',
        'coteInput':'.coteInput',
        'history':'.history',
        'playerName':'.playerName'
    },
    load: function(){
        $.ajax({
            url: './apis/recote/details/' + this.getOption('playerId') + (this.getOption('seasonId') ? '/' + this.getOption('seasonId') : ''),
            cache: false,
            success: _.bind(this.onLoad, this)
        });
    },
    onLoad: function(response){
        this.cotations.reset(response.cotations)
        this.stats.reset(response.stats)
        this.history.reset(response.history);
        this.careerStats.reset(response.careerStats)
        this.player = new Backbone.Model(response.player)
        this.showCoteInput();
    },
    onRender: function(){
        this.showChildView('stats', new StatsView({collection: this.stats}))
        this.showChildView('careerStats', new CareerStatsView({collection: this.careerStats}))
        this.showChildView('cotations', new CotationsView({collection: this.cotations}));
        this.showChildView('history', new RecoteHistory({collection: this.history}));
        this.showCoteInput();
    },
    showCoteInput(){
        if(this.player){
            this.showChildView('coteInput', new CoteInput({model: this.player}));
            this.showChildView('playerName', new playerNameView({model: this.player}));
        }
    }
})

export const RecoteBootstraper = M.View.extend({
    template: _.template(''),
    initialize: function(){
        // do not alter content
        this.template = _.template(this.$el.html())
    },
    triggers: {
        'click': 'click',
    },
    onClick: function(){
        showModal('Cote', new RecoteDetails({playerId: this.getOption('playerId')}))
    }
})